<template>
    <div>
      <add-task-modal :project="project"></add-task-modal>
      <div class="col-lg-12">
        <button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#add-task">Create new task</button>
      </div>
      <tasks-filters :project="project"></tasks-filters>
      <tasks-list></tasks-list>
    </div>
</template>
<script>
import AddTaskModal from '../../../../Tasks/AddTaskModal.vue'
import TasksFilters from '../../../../Tasks/Filters.vue'
import TasksList from '../../../../Tasks/List.vue'

export default {
  props: {
    project: {}
  },
  components: {
    tasksFilters: TasksFilters,
    tasksList: TasksList,
    addTaskModal: AddTaskModal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Projects/Single/Content/Tabs/ProjectTasks.vue